import {emptyParametersByType} from '../components/ruleset/TargetTypeSelector'
import {INCLUDE_ALL_PATTERN} from '../types/rules-types'
import type {
  Condition,
  ConditionParameters,
  IncludeExcludeParameters,
  TargetObjectType,
  TargetType,
  TargetWithParameters,
} from '../types/rules-types'

export function isAllCondition(targetType: TargetType, parameters: ConditionParameters) {
  const params = parameters as IncludeExcludeParameters
  return (
    (targetType === 'repository_name' || targetType === 'organization_name') &&
    params.include.length === 1 &&
    params.include[0] === INCLUDE_ALL_PATTERN &&
    params.exclude.length === 0
  )
}

export function getTargetMode(condition: Condition) {
  return isAllCondition(condition.target, condition.parameters) ? 'all_repos' : condition.target
}

export function getDefaultTargetByObject(
  objectType: TargetObjectType,
  options?: {
    supportedConditionTargetObjects?: TargetObjectType[]
  },
): TargetWithParameters {
  if (objectType === 'repository' && options?.supportedConditionTargetObjects?.includes('organization')) {
    return {
      type: 'repository_name',
      parameters: emptyParametersByType('all_repos'),
    }
  }

  const objectMap: Record<TargetObjectType, TargetType> = {
    organization: 'organization_name',
    repository: 'repository_property',
    ref: 'ref_name',
  }
  const targetType = objectMap[objectType]
  if (!targetType) {
    throw new Error(`Unknown target object type: ${objectType}`)
  }

  return {
    type: targetType,
    parameters: emptyParametersByType(targetType),
  }
}
